import { createSelector } from 'reselect'
// import { List } from 'immutable'

const lobSelector = state => state.get('lob')

export const getIsFetching = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return lob.lobCreate.isFetching
    || lob.lobEdit.isFetching
    || lob.lobDeactivate.isFetching
    || lob.lobGet.isFetching
    || lob.lobList.isFetching
    || lob.lobExport.isFetching
  }
)
export const getCreateLOBData = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return lob.lobCreate
  }
)
export const getEditLOBData = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return lob.lobEdit
  }
)
export const getDeactivateLOBData = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return lob.lobDeactivate
  }
)
export const getLOBData = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return lob.lobGet.lob
  }
)
export const getListLOB = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return lob.lobList.lobs
  }
)
export const getExportURL = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return lob.lobExport.url
  }
)
export const redirectLOB = createSelector(
  lobSelector,
  lobImmutable => {
    const lob = lobImmutable.toJS()
    return ({
      redirect: (lob.lobCreate.redirect
      || lob.lobEdit.redirect
      || lob.lobDeactivate.redirect
      || lob.lobGet.redirect
      || lob.lobList.redirect
      || lob.lobExport.redirect),
      isAuthenticated: (lob.lobCreate.isAuthenticated
      || lob.lobEdit.isAuthenticated
      || lob.lobDeactivate.isAuthenticated
      || lob.lobGet.isAuthenticated
      || lob.lobList.isAuthenticated
      || lob.lobExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/lob/lob-selector.js